<template>
    <div>
        <ScanUploadComment v-if="(commentPosition === 'before') && !compactMode" />

        <div class="form-group input-group-sm" style="margin-top: 20px" v-if="!compactMode">
            <GetRequestBlank />
        </div>

        <p v-if="uploaded && showUploadedComment">
            <small class="text-success">Скан заявления на членство загружен. <a href="#" v-if="compactMode" @click.prevent="compactModeOffByUser = true">Загрузить повторно?</a></small>
        </p>

        <div class="form-group input-group-sm" v-if="!compactMode">
            <button type="button" class="btn btn-info btn-sm" @click="loadPhoto">{{ uploaded ? 'Загрузить скан заявления повторно' : 'Загрузить скан заявления' }}</button>
            <input
              type="file"
              style="display: none;"
              ref="photoFileInput"
              accept="image/*,application/pdf"
              @change="upLoad"
            />
        </div>
        <ScanUploadComment v-if="(commentPosition === 'after') && !compactMode"/>
    </div>
</template>
<script>

import ScanUploadComment from '@/components/requestScanUploadComment.vue'
import GetRequestBlank from '@/components/GetRequestBlank.vue'

export default {
    props: {
        commentPosition: {
            type: String,
            default: 'after',
        },
        showUploadedComment: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            uploaded: this.$store.getters.getUserData.memberInfo?.isRequestScanUploaded,
            compactModeOffByUser: false,
        };
    },
    computed: {
        compactModePossible() {
            return this.uploaded && this.showUploadedComment;
        },
        compactMode() {
            return this.compactModePossible && !this.compactModeOffByUser;
        },
    },
    components: {
        ScanUploadComment,
        GetRequestBlank,
    },
    methods: {
        loadPhoto() {
            this.$refs.photoFileInput.click()
        },
        upLoad(event) {
            const input = event.target;
            if (input.files && input.files[0]) {
                const data = new FormData();
                data.append('request', input.files[0], input.files[0].name);
                this.$store.dispatch('saveRequestScan', data).then(() => this.uploaded = true);
            }
        }
    }
}
</script>
